import { Component, Input, OnInit } from '@angular/core';
import { BaseCRMItem } from '../../models/crm/CRMItem.model';
import { Observable } from 'rxjs';
import { Note } from '../../models';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CrmUtilsService } from '../../../core/data-services/crm-utils.service';
import { CrmNoteService } from '../../../core/data-services/crm-note.service';
import { CONFIG } from '../../../config';

@Component({
    selector: 'rms-crm-quick-note-modal',
    templateUrl: './crm-quick-note-modal.component.html',
    styleUrls: ['./crm-quick-note-modal.component.scss'],
    standalone: false
})
export class CrmQuickNoteModalComponent implements OnInit {

  @Input() crmItem: BaseCRMItem;
  @Input() overviewNoteObs:  Observable<Note>;
  @Input() crmNoteObs: Observable<Note>;

  public noteText = '';
  public overviewNote: Note = null;
  public crmNote: Note = null;

  public readonly formatEST = CONFIG.formatEST;

  constructor(
    public activeModal: NgbActiveModal,
    public crmUtilsService: CrmUtilsService,
    public crmNoteService: CrmNoteService,
  ) { }

  ngOnInit() {
    this.overviewNoteObs.subscribe(note => this.overviewNote = note);
    this.crmNoteObs.subscribe(note => this.crmNote = note);
  }

  public submit() {
    if (this.noteText) {
      this.activeModal.close(this.noteText);
    }
  }

  public close() {
    this.activeModal.close(null);
  }

  public getHref(note: Note) {
    return `/company/${this.crmItem.companies[0].company.id}?noteId=${note.id}`;
  }

  public getNoteAuthor(note: Note) {
    return note && note.textContent && note.textContent.createdBy ?
      `(${note.textContent.createdBy.firstName} ${note.textContent.createdBy.lastName.substring(0, 1)}.)`
      : null;
  }
}
